import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";

import Navbar from "@/components/Navbar";
import Landing from "@/pages/Landing";
import PainterSignup from "@/pages/PainterSignup";
import FindPainter from "@/pages/FindPainter";
import WorkerProfile from "@/pages/WorkerProfile";
import ReviewRequest from "@/pages/ReviewRequest";
import QuoteApproval from "@/pages/QuoteApproval";
import WorkerLogin from "@/pages/WorkerLogin";
import WorkerDashboard from "@/pages/WorkerDashboard";
import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/pages/AdminLayout";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminWorkers from "@/pages/AdminWorkers";
import AdminLeads from "@/pages/AdminLeads";
import AdminQuotes from "@/pages/AdminQuotes";
import AdminJobs from "@/pages/AdminJobs";
import AdminReviews from "@/pages/AdminReviews";
import AdminBroadcast from "@/pages/AdminBroadcast";
import { Toaster } from "@/components/ui/sonner";
import { useGAPageView } from "@/lib/analytics";

const RouteTracker = () => {
  useGAPageView();
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <RouteTracker />
        <Navbar />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/get-started" element={<PainterSignup />} />
          <Route path="/find-painter" element={<FindPainter />} />
          <Route path="/u/:slug" element={<WorkerProfile />} />
          <Route path="/review/:jobId" element={<ReviewRequest />} />
          <Route path="/quote/:quoteId" element={<QuoteApproval />} />
          <Route path="/worker/login" element={<WorkerLogin />} />
          <Route path="/worker" element={<WorkerDashboard />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="workers" element={<AdminWorkers />} />
            <Route path="leads" element={<AdminLeads />} />
            <Route path="quotes" element={<AdminQuotes />} />
            <Route path="jobs" element={<AdminJobs />} />
            <Route path="reviews" element={<AdminReviews />} />
            <Route path="broadcast" element={<AdminBroadcast />} />
          </Route>
        </Routes>
        <Toaster richColors closeButton position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
